import * as PUBLIC_HOSTS from './publicHosts'

export * as PUBLIC_HOSTS from './publicHosts'

export type HOST = typeof PUBLIC_HOSTS
export type HOSTKEY = keyof typeof PUBLIC_HOSTS
export type HOSTVALUE = HOST[HOSTKEY]

export let PUBLIC_HOSTS_KEYS = Object.keys(PUBLIC_HOSTS).reduce((cur, next) => {
  cur[next] = next
  return cur
}, {}) as {
  [k in HOSTKEY]: k
}